(window as any).pdfWorkerSrc = '/assets/lib/pdf.worker.min.js';

export * from './public-api';
